import React from 'react';
import ReactDOM from 'react-dom';
import { JustList } from './JustList';


ReactDOM.render(
    <JustList />,
  document.getElementById('root')
);
